import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
                <i className="ri-smartphone-line w-4 h-4 flex items-center justify-center"></i>
                <span>移动端体验</span>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
                {appData.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
                {appData.intro}
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 md:gap-4">
                {appData.steps.map((step, i) => (
                  <div key={i} className="flex items-center gap-2 text-sm text-foreground-600">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className={`${step.icon} text-sm`}></i>
                    </div>
                    <span>{step.text}</span>
                    {i < appData.steps.length - 1 && (
                      <span className="hidden sm:block text-foreground-300 mx-1">
                        <i className="ri-arrow-right-s-line"></i>
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="w-40 md:w-48 flex-shrink-0">
              <div className="w-full aspect-[9/16] rounded-2xl bg-background-100 border-4 border-background-200/70 overflow-hidden">
                <div className="w-full h-full flex flex-col items-center justify-center gap-2 p-4">
                  <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500 text-background-50 font-bold text-sm">
                    51
                  </span>
                  <span className="text-xs font-medium text-foreground-700 text-center">51吃瓜网</span>
                  <span className="text-[10px] text-foreground-400 text-center">随时随地点开就吃</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}